export const MESSAGE_EMPTY_BOT_SELECT_OPTION = 'Не выбран'